export default __webpack_public_path__ + "static/media/marauders-map-v5.2-gallery-05.75de6f67.jpg";